import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import { getNewsHeader } from '@/services/news'
import { getTags } from '@/services/tags'
import { wrapper } from '@/store'

import PressRelease from './PressRelease'

const Page: NextPage = () => {
  return (
    <main className='min-h-screen bg-gray-100'>
      <PressRelease />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale }) => {
  const paramsList = {
    params: { skip: 0, limit: 5 },
    headers: { 'Accept-Language': String(locale) },
  }
  await Promise.all([
    store.dispatch(getNewsHeader.initiate({ headers: { ...paramsList.headers } })),
    store.dispatch(getTags.initiate(paramsList)),
    store.dispatch(getFloatingMenu.initiate({ headers: { ...paramsList.headers } })),
  ])
  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'press'])),
    },
  }
})

export default Page
